import { Component, OnInit } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory-service';
import { Warehouse, Inventory } from 'src/app/models/warehouse';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.css']
})
export class WarehouseComponent implements OnInit {
  warehouses:Warehouse[] = [];
  warehouse:Warehouse = new Warehouse();
  inventory:Inventory[] = [];

  loading:boolean = false;
  withInv:boolean = true;

  totalAvgPrice:number = 0;
  totalMinPrice:number = 0;
  totalMaxPrice:number = 0;

  constructor( private invServ:InventoryService ) { }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.invServ.getWarehouses(true).then(warehouses => {
      this.warehouses = warehouses;
      this.selectWarehouse(this.warehouses[0]);
      this.loading = false;
    });
  }

  selectWarehouse(wh:Warehouse) {
    this.warehouse = wh;
    this.filterInventory();
    this.totalAvgPrice = 0;
    this.totalMinPrice = 0;
    this.totalMaxPrice = 0;

    this.inventory.filter(x => Number(x.quantity) || Number(x.maintenance_warehouse)).forEach(x => {
      this.totalAvgPrice += Number(x.avg_price) * (Number(x.maintenance_warehouse) + Number(x.quantity));
      this.totalMinPrice += Number(x.min_price) * (Number(x.maintenance_warehouse) + Number(x.quantity));
      this.totalMaxPrice += Number(x.max_price) * (Number(x.maintenance_warehouse) + Number(x.quantity));
    });
  }

  filterInventory() {
    this.inventory = this.warehouse.inventory.filter(x => (this.withInv && (x.quantity > 0 || x.maintenance_warehouse > 0)) || (!this.withInv));
  }

}
